import LoginForm from "@/components/forms/LoginForm";
import { motion } from "framer-motion";
import AuthDisplay from "./components/AuthDisplay";
import HelmetMetaData from "@/components/HelmetMetaData";
import { useMediaQuery } from "react-responsive";
import { cn } from "@/lib/utils";

const Login = () => {
  const smallerScreen = useMediaQuery({ query: "(max-width: 380px)" });

  return (
    <>
      <HelmetMetaData
        title="Login - Access Your Billzpay Account"
        description="Log in to your Billzpay account to access seamless payment features. Enjoy instant airtime recharges, data bundle purchases, and more. If you don't have an account, consider registering for a hassle-free experience!"
      />

      <section
        style={{
          background:
            "linear-gradient(135deg, #223867 0%, #33559b 50%, #111c34 100%)",
        }}
        className="h-dvh overflow-y-hidden"
      >
        <div className="flex h-full w-full items-center justify-center border border-white/10 lg:flex-row lg:justify-start">
          <div className="dark:bg-darkBg relative h-full w-full overflow-hidden rounded-none bg-white p-4 md:h-[650px] md:w-[450px] lg:h-full lg:w-[40%] lg:px-10">
            {/* <img
              src="/logo.svg"
              alt="billzpay-logo"
              className="absolute top-3 right-5 w-12 lg:w-14"
            /> */}

            <div className="flex h-full w-full items-center">
              <div className="w-full rounded-3xl py-10 xl:p-10 xl:shadow-2xl">
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className={cn(
                    "font-archivo mb-2 text-[2.4rem] leading-[1] font-semibold text-black/85 lg:text-[2.3rem] dark:text-white",
                    smallerScreen && "text-[2rem]",
                  )}
                >
                  Access Your Account
                </motion.h2>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
                  className="leading-[1.3] text-gray-500 dark:text-gray-300"
                >
                  Welcome Back, Log in to access your account and continue.
                </motion.p>

                <LoginForm />

                {/* <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
                  className="absolute bottom-4 left-1/2 mt-10 w-full -translate-x-1/2 text-xs text-gray-400 lg:mt-5 dark:text-gray-300"
                >
                  <p className="text-center">
                    By signing up, you agree to Billzpay <br />{" "}
                    <span className="font-medium text-black hover:underline dark:text-white">
                      Terms & Conditions
                    </span>{" "}
                    and{" "}
                    <span className="font-medium text-black hover:underline dark:text-white">
                      Privacy policy
                    </span>
                  </p>
                </motion.div> */}
              </div>
            </div>
          </div>

          <AuthDisplay />
        </div>
      </section>
    </>
  );
};

export default Login;
